import { useState, useEffect } from 'react'
import { motion } from 'framer-motion'

const NOTE = `Hi — I wanted to flag something before we finalize par levels for next week.

Retractor consumption (FLR02) is running about 34% above our prior 30-day average, and we haven't been able to trace it to a specific procedure or schedule change in our data.

J&J's demand sensing agent has seen this pattern at a few comparable accounts — in most cases it was linked to a new attending or a technique change on the surgical side.

If there's been any shift in how the team is approaching retraction, it would help us get ahead of it before it becomes a supply issue.

Happy to connect this week if easier.

Thanks, Sara.`

export default function NoteModal({ onSend, onCancel }) {
  const [displayed, setDisplayed] = useState('')
  const [done, setDone] = useState(false)

  useEffect(() => {
    let i = 0
    const id = setInterval(() => {
      i++
      setDisplayed(NOTE.slice(0, i))
      if (i >= NOTE.length) {
        setDone(true)
        clearInterval(id)
      }
    }, 9)
    return () => clearInterval(id)
  }, [])

  return (
    <motion.div
      layout
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3, layout: { duration: 0.45, ease: [0.16, 1, 0.3, 1] } }}
      style={{
        flex: 1,
        minWidth: 0,
        height: '100%',
        background: '#F7F6F4',
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      {/* Header */}
      <div style={{
        padding: '20px 28px 16px',
        flexShrink: 0,
      }}>
        <span style={{
          fontSize: 10, fontWeight: 700,
          color: '#A39992',
          textTransform: 'uppercase', letterSpacing: '0.09em',
        }}>
          Note to OR Nurse Manager
        </span>
      </div>

      {/* Note body */}
      <div style={{ flex: 1, padding: '4px 28px 20px', overflowY: 'auto' }}>
        <p style={{
          fontSize: 14,
          color: '#1C1C1C',
          lineHeight: 1.8,
          whiteSpace: 'pre-line',
          margin: 0,
          fontWeight: 400,
        }}>
          {displayed}
          {!done && (
            <motion.span
              animate={{ opacity: [1, 1, 0, 0] }}
              transition={{ duration: 0.8, repeat: Infinity, times: [0, 0.4, 0.5, 1] }}
              style={{
                display: 'inline-block',
                width: 2,
                height: '1em',
                background: '#1C1C1C',
                verticalAlign: 'text-bottom',
                marginLeft: 2,
                borderRadius: 1,
              }}
            />
          )}
        </p>
      </div>

      {/* Footer */}
      <div style={{
        padding: '14px 28px 20px',
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        flexShrink: 0,
        borderTop: '1px solid rgba(0,0,0,0.07)',
      }}>
        <motion.button
          whileHover={{ filter: 'brightness(1.12)' }}
          whileTap={{ scale: 0.97 }}
          onClick={onSend}
          style={{
            flex: 1, height: 40, borderRadius: 8,
            background: '#EB1700', border: 'none',
            color: '#FFFFFF', fontSize: 13, fontWeight: 600,
            cursor: 'pointer', fontFamily: 'inherit',
          }}
        >
          Send
        </motion.button>
        <motion.button
          whileHover={{ color: '#555' }}
          whileTap={{ scale: 0.97 }}
          onClick={onCancel}
          style={{
            padding: '0 16px', height: 40,
            background: 'transparent', border: 'none',
            color: '#A39992', fontSize: 13, fontWeight: 500,
            cursor: 'pointer', fontFamily: 'inherit',
            flexShrink: 0,
          }}
        >
          Cancel
        </motion.button>
      </div>
    </motion.div>
  )
}
